import React, { useState, useEffect } from 'react';
import coreXTextImage from '../images/CorexasLogoWithoutText.png';
import backgroundImage from "../images/Background.png";
import baslaButtonImage from '../images/tr/BaslaButton.png';
import styles from './IntroPages.module.css';
import { useParams } from 'react-router-dom';

function QuizStarterPage({ navigate }) {
    const { quizType } = useParams();
    const [quizName, setQuizName] = useState("");

    const handleBasla = async () => {
        let route = '';
        if (quizType === "innovation") {
            route = '/quiz/innovation/ProblemAnaBoyut.json/PROBLEM';
        } else if (quizType === "technology") {
            route = '/quiz/technology/OperasyonAnaBoyut.json/OPERASYON';
        } else if (quizType === "sustainability") {
            route = '/quiz/sustainability/OperasyonAnaBoyut.json/OPERASYON';
        } else if (quizType === "strategy") {
            route = '/quiz/strategy/StratejiAnaBoyut.json/STRATEJİ';
        }
        
        const companyName = localStorage.getItem('companyName');
        try {
            const response = await fetch(`https://corexas-analysis-backend-i1q0.onrender.com/api/progress/${encodeURIComponent(companyName)}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: localStorage.getItem('jwt'),
                },
                body: JSON.stringify({
                    latestVisitedRoute: route,
                }),
            });
            if (!response.ok) {
                console.error('Failed to update progress.');
            }
        } catch (error) {
            console.error('Error updating progress:', error);
        }

        navigate(route);
    };

    useEffect(() => {
        switch (quizType) {
            case "innovation":
                setQuizName("İnovasyon\nAr-Ge");
                break;
            case "technology":
                setQuizName("Teknoloji");
                break;
            case "sustainability":
                setQuizName("Sürdürülebilirlik");
                break;
            case "strategy":
                setQuizName("Strateji");
                break;
            default:
                break;
        }
    }, [quizType])
    

    return (
        <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Bookman Old Style", flexDirection: "column" }}>
            <div className={styles.content} style={{}}>
                <div className={styles.leftside} style={{ paddingLeft: "2vw", paddingTop: "5vh", flexDirection: "row", display: "flex", justifyItems: "center" }}>
                    <img src={coreXTextImage} alt="CoreXFuture" style={{ height: "16vh", alignSelf: "center" }} />
                    <h2 style={{ fontFamily: "Bookman Old Style", fontSize: "7vh", paddingBottom: "1vh", paddingLeft: "1vw", color: "#c4eff7", whiteSpace: "pre-wrap", textAlign: "left" }}>{quizName}</h2>
                </div>
                <div className={styles.rightside} style={{}}>
                    <div className={styles.buttoncontainer} style={{}} >
                        <img
                            src={baslaButtonImage}
                            alt="Başla"
                            className={styles.startbutton}
                            onClick={handleBasla}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuizStarterPage;